var map = {
	"./404.svg": 970,
	"./Categories.png": 719,
	"./Edit-menu.svg": 971,
	"./Egg.svg": 972,
	"./Emaier-Header.png": 973,
	"./Qr-4.png": 974,
	"./_duplicate.svg": 975,
	"./_overview.svg": 976,
	"./add-white.svg": 977,
	"./alert.svg": 978,
	"./all_category.svg": 979,
	"./archive.svg": 980,
	"./armchair.svg": 981,
	"./arrow-circle-right.svg": 982,
	"./arrow-left-circle.svg": 983,
	"./arrow-right-circle.svg": 984,
	"./arrow-right.svg": 985,
	"./asc-up-white.svg": 986,
	"./asc.png": 987,
	"./asc.svg": 988,
	"./back-arrow.svg": 989,
	"./barcode-icon.svg": 990,
	"./beverages.svg": 991,
	"./blue-edit-pen.svg": 992,
	"./blue-eye.svg": 993,
	"./box-office.svg": 994,
	"./broken-seat.jpg": 995,
	"./calendar_list.svg": 996,
	"./calender.svg": 367,
	"./chevron-down.svg": 997,
	"./chevron-left.svg": 998,
	"./cinema-mamagement-sidebar.svg": 999,
	"./claendar.svg": 368,
	"./clock-1.svg": 1000,
	"./clock.svg": 1001,
	"./close-button.svg": 726,
	"./close-white.svg": 732,
	"./close-x.svg": 311,
	"./collapse-up.svg": 1002,
	"./collapse.svg": 1003,
	"./connection-lost.svg": 365,
	"./consumable-raw-material.svg": 1004,
	"./copy.svg": 1005,
	"./copy_image_icon.png": 1006,
	"./delete-red-light.svg": 1007,
	"./delete-red.svg": 733,
	"./delete.svg": 707,
	"./deliver-icon.svg": 1008,
	"./desc-down-white.svg": 1009,
	"./desc.svg": 1010,
	"./distributors-sidebar.svg": 1011,
	"./download.svg": 1012,
	"./dragndrop.svg": 1013,
	"./dragndrop2.svg": 1014,
	"./duplicate.svg": 1015,
	"./duplicateScreen.svg": 1016,
	"./e-wallet-icon-black.svg": 1017,
	"./edit-pen-blue.svg": 1018,
	"./edit-pen-white.svg": 1019,
	"./edit-pen.svg": 1020,
	"./edit.svg": 1021,
	"./email.png": 1022,
	"./empty-image.svg": 1023,
	"./excel.svg": 1024,
	"./external-link.svg": 1025,
	"./eye.svg": 1026,
	"./filter-icon.svg": 1027,
	"./flag.svg": 1028,
	"./fnb-app-order.svg": 1029,
	"./fnb-beverages.svg": 1030,
	"./fnb-brownie.svg": 1031,
	"./fnb-combo.svg": 1032,
	"./fnb-desert.svg": 1033,
	"./fnb-eatables.svg": 1034,
	"./fnb-make-your-combo.svg": 1035,
	"./fnb-popcorn.svg": 1036,
	"./fnbtransactionIcon.svg": 1037,
	"./fullscreen-icon.svg": 734,
	"./funnel.svg": 1038,
	"./globe.svg": 1039,
	"./green-tick.svg": 1040,
	"./grid-view.svg": 1041,
	"./hide-password.svg": 369,
	"./home-icon.svg": 1042,
	"./home.svg": 1043,
	"./icon-black-play.svg": 1044,
	"./icon-dot.svg": 1045,
	"./icon-fnb.svg": 1046,
	"./icon-marketing.svg": 1047,
	"./icon-no-seat.png": 1048,
	"./icon-no-seat.svg": 1049,
	"./icon-option.svg": 1050,
	"./icon-poin-of-sale.svg": 1051,
	"./icon-recliner.svg": 1052,
	"./icon-report.svg": 1053,
	"./icon-sofa-dark-1.svg": 1054,
	"./icon-sofa-dark.png": 1055,
	"./icon-sofa-dark.svg": 1056,
	"./icon-sofa.svg": 1057,
	"./importfile.svg": 1058,
	"./info.svg": 735,
	"./info2.svg": 1059,
	"./keyboard-icon.svg": 1060,
	"./kitchen_display.svg": 1061,
	"./language-icon.svg": 1062,
	"./left-caret.svg": 1063,
	"./link.svg": 1064,
	"./list-view.svg": 1065,
	"./loading.svg": 370,
	"./lock.svg": 1066,
	"./login-password.png": 371,
	"./login-user.png": 372,
	"./logout.svg": 736,
	"./masters-sidebar.svg": 1067,
	"./merchandise.svg": 1068,
	"./minus.svg": 1069,
	"./movie-pass-svg.svg": 717,
	"./movie-rolling.svg": 1070,
	"./mulitSchedule.svg": 1071,
	"./multicurrency.svg": 1072,
	"./multifnb.svg": 1073,
	"./nav-plus.svg": 1074,
	"./new_filter_icon.svg": 1075,
	"./no-image.svg": 1076,
	"./no-schedule.svg": 143,
	"./non-veg-mark.png": 1077,
	"./non-veg-mark.svg": 1078,
	"./notification.svg": 1079,
	"./open-link-blue.svg": 1080,
	"./openPlanned.svg": 1081,
	"./overview.svg": 1082,
	"./overview2.svg": 1083,
	"./pdf-icon.svg": 1084,
	"./pdf.svg": 1085,
	"./pickup-ticket-icon.svg": 1086,
	"./pickupfnb.svg": 1087,
	"./play.svg": 1088,
	"./plus.svg": 1089,
	"./pointofsale-1.svg": 1090,
	"./pointofsale-2.svg": 1091,
	"./pointofsale.png": 1092,
	"./portfolio.svg": 1093,
	"./pos-fnb-no-itmes.svg": 720,
	"./pos-refresh.svg": 1094,
	"./primary/chevron-down.svg": 1095,
	"./primary/download.svg": 1096,
	"./primary/edit.svg": 1097,
	"./primary/filter.svg": 1098,
	"./primary/printer.svg": 1099,
	"./print-icon.svg": 1100,
	"./print.svg": 1101,
	"./question.svg": 1102,
	"./question1.svg": 1103,
	"./question2.svg": 737,
	"./question3.svg": 1104,
	"./recliner-1.svg": 1105,
	"./recliner.png": 1106,
	"./refund-icon.svg": 1107,
	"./reload-icon-pos.svg": 1108,
	"./reload-icon.svg": 1109,
	"./restore.svg": 1110,
	"./right-caret.svg": 1111,
	"./role-management-sidebar.svg": 1112,
	"./save.svg": 1113,
	"./schedule-icon.svg": 1114,
	"./school-calendar.svg": 1115,
	"./search-global-white.svg": 1116,
	"./search-global.svg": 1117,
	"./search.svg": 738,
	"./searchIcon.svg": 1118,
	"./seat-icon-2.svg": 1119,
	"./seat-icon.svg": 1120,
	"./seat-icons/3-wheelChair.png": 1121,
	"./seat-icons/block_seat_new.png": 1122,
	"./seat-icons/broken-seat-1.svg": 1123,
	"./seat-icons/broken-seat-2.svg": 1124,
	"./select-food.png": 739,
	"./settings.svg": 1125,
	"./show-password.svg": 373,
	"./slider-triangle.svg": 729,
	"./snack.svg": 740,
	"./sort.svg": 1126,
	"./star-empty.svg": 1127,
	"./star-fill.svg": 1128,
	"./success-tick.svg": 1129,
	"./suitcase.svg": 1130,
	"./swap.svg": 1131,
	"./tick-green-item.svg": 741,
	"./tick-green.svg": 1132,
	"./ticket-icon.svg": 1133,
	"./trash.svg": 1134,
	"./unpaid-reservation.svg": 711,
	"./updown-white.svg": 1135,
	"./updown.svg": 1136,
	"./user-attribute.svg": 1137,
	"./user-attributes.svg": 1138,
	"./user-female.svg": 1139,
	"./user-male-white.svg": 1140,
	"./user-male.svg": 1141,
	"./user-profile.svg": 1142,
	"./userProfile.png": 1143,
	"./veg-food-mark-white.png": 1144,
	"./veg-foog-mark-trans.png": 1145,
	"./view.png": 1146,
	"./view.svg": 1147
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 969;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 969
// module chunks = 38